// client/src/components/influencer/InfluencerTabbar.js
// 마이비즈 모바일 하단 탭바 (≤1024px, mb-ui.css 재사용 · ib-theme 민트)
// v4 시안 확정: 홈 / 내 활동 / 지원(중앙 FAB) / 포인트 / 내 정보
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TAB_OF } from './influencerMybizNav';

const ICONS = {
  home: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 10.5 12 3l9 7.5" /><path d="M5 9.5V21h14V9.5" /></svg>
  ),
  work: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="3" /><path d="M8 3v4M16 3v4M3 10h18" /></svg>
  ),
  apply: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M12 5v14M5 12h14" /></svg>
  ),
  point: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
  ),
  my: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" /></svg>
  ),
};

// 탭 터치 시 이동할 대표 화면
// 하단 탭바는 폭 제약(≤1024px 전용, 항목당 min-width 56px)으로 병기 제외 — 심사 스크린캐스트는 데스크톱 뷰포트라 노출되지 않음
const TABS = [
  { key: 'home', label: '홈', sub: 'home' },
  { key: 'work', label: '내 활동', sub: 'resultSend' },
  { key: 'apply', label: '지원', sub: 'projectApply', center: true },
  { key: 'point', label: '포인트', sub: 'pointList' },
  { key: 'my', label: '내 정보', sub: 'snsView' },
];

function InfluencerTabbar() {
  const nav = useNavigate();
  const location = useLocation();
  const sub = new URLSearchParams(location.search).get('sub');
  const currentTab = TAB_OF[sub] || 'home';

  return (
    <nav className="mb-tabbar" aria-label="마이비즈 주요 메뉴">
      {TABS.map((t) => {
        const active = currentTab === t.key;
        if (t.center) {
          return (
            <button
              key={t.key}
              type="button"
              className={`mb-tabbar__item mb-tabbar__item--new ${active ? 'is-active' : ''}`}
              onClick={() => nav(`/influencer/mybiz?sub=${t.sub}`)}
            >
              <span>{ICONS[t.key]}</span>
              <em>{t.label}</em>
            </button>
          );
        }
        return (
          <button
            key={t.key}
            type="button"
            className={`mb-tabbar__item ${active ? 'is-active' : ''}`}
            onClick={() => nav(`/influencer/mybiz?sub=${t.sub}`)}
          >
            {ICONS[t.key]}
            {t.label}
          </button>
        );
      })}
    </nav>
  );
}

export default InfluencerTabbar;
